import { Guid } from "@/Common/Models/Guid";
import { IndividualMessageNote } from "@/Common/Models/NotesPopup/IndividualMessageNote";
import { CommunicationsUIStateInbox } from "@/Common/Models/UI/Enums";

class MessageOrTaskItem {
    public Id: string;
    public Version: number;
    public Subject: string;
    public Body: string;
    public SendDate: Date;
    public StartDate: Date;
    public DueDate: Date;
    public IsDraft: boolean;
    public IsGroupTask: boolean;
    public DocumentPatientId: string;
    public Filename: string;
    public PriorityLookupId: string;

    public MessageState: CommunicationsUIStateInbox;
    public IsActionPossible: boolean;
    public FromContact: IndividualDTO;
    public FromContactId: string;
    public ToContact: IndividualDTO[]; // After 15 the count will be truncated, use "ToContactCount"
    public SharedInboxContacts: IndividualDTO[]; // Shared Inboxes Detected for the Following Contacts.

    public ToContactCount: number;

    public IsTrash: boolean;
    public IsArchive: boolean;
    public IMS_ID: string;
    public IM_ID: string;
    public IsRead: boolean;
    public SearchString: string;
    public PatientLinks: IndividualDTO[];

    // to optimize sorting when doing client side sorting
    public ClinicianFromLastName: string;
    public ClinicianToLastName: string;
    public PatientLastName: string;
    public PriorityString: string;
    // ---------------------------

    public IsTask: boolean;

    // Task
    public IsDone: boolean;
    public TaskStatusLookupId: string; // Guid Empty if current user do not have a task status in the dB yet
    public GenericTaskStatusLookupId: string;
    public TypeTaskLookupId: string;

    public Notes: IndividualMessageNote[];
    public TotalNotes: number;

    constructor() {
        this.Notes = [];
    }
}

class IndividualDTO {
    public Id: Guid;
    public FirstName: string;
    public PreferredName: string;
    public LastName: string;
    public TaskStatusLookupId: string;
    public IMS_ID: string;
    public LastStatusUpdatedDate: Date;
    public PrefixLookupId: string;
}

export { IndividualDTO, MessageOrTaskItem };
